import React, {
    Fragment,
    useState,
    useEffect,
    useRef,
    useMemo,
    useCallback,
  } from 'react'
  import {
     getMlmfoutletMaster,getoutletListMaster,getCompanyListMaster,getDeliveryslotListMaster
  } from "../../../../apiservicescall/api";
  import Table from "@mui/material/Table";
  import { MuiThemeProvider, createMuiTheme } from "@material-ui/core/styles";
  import MUIDataTable from "mui-datatables";
  import Stepper from "@material-ui/core/Stepper";
  import Step from "@material-ui/core/Step";
  import StepLabel from "@material-ui/core/Step";
  import StepButton from "@material-ui/core/StepButton";
  import RctCollapsibleCard from "../RctCollapsibleCard/RctCollapsibleCard";
  import {
    // Table,
    Badge,
    Row,
    Card,
    Col,
    Button,
    Container,
    ListGroup,
    Tab,
  } from "react-bootstrap";
  import { Link } from "react-router-dom";
  
  import Select from "react-select";
  
  import {
    Pagination,
    PaginationItem,
    PaginationLink,
    Modal,
    ModalHeader,
    ModalBody,
    ModalFooter,
  } from "reactstrap";
  import swal from "sweetalert";
  import { Form, FormGroup, Label, Input } from "reactstrap";
  import { KeyboardDatePicker, MuiPickersUtilsProvider } from '@material-ui/pickers';
  import DateFnsUtils from "@date-io/date-fns";
  import DatePicker from 'react-datepicker';
  import "react-datepicker/dist/react-datepicker.css";
  import { Edit } from '@material-ui/icons';
  


const Deliveryslot = () => {
  const [restarantvalue, setRestarantvalue] = useState([{ label: "", value: "", }]);
  const [outletMasterlist, setOutletMasterlist] = useState([]);
  const [companyMaster, setCompanyMaster] = useState([]);
  const [outletvalue, setOutletvalue] = useState([{ label: "", value: "", }]);

  const [deliverySlot, setDeliverySlot] = useState([]);

  const [currentPage, setCurrentPage] = useState(0);
  const [totalPages, setTotalPages] = useState(0);
  const [totalItems, setTotalItems] = useState(0);
  const [itemsPerPage, setItemsPerPage] = useState(10);

  useEffect(() => {
    getcompanyMasterList();

  }, []);

  const getcompanyMasterList = async () => {

    let getoutletList = await getCompanyListMaster();
    let getoutletListValue = getoutletList?.data?.data;
    let companyoutmaster = getoutletListValue.map(({ compCode, compName }) => ({
      label: compName,
      value: compCode,
    }));

    getoutletMasterList(getoutletListValue[0]?.compCode);
  };



  const getoutletMasterList = async (companyCode) => {
    let getoutletList = await getoutletListMaster(companyCode);
    let getoutletListValue = getoutletList?.data?.data;
    let companyoutmaster = getoutletListValue
      && getoutletListValue.map(({ outletCode, outletName }) => ({
        label: `${outletCode}-${outletName}`,
        value: outletCode,
      }));
    // console.log("companyoutmaster", companyoutmaster);
    setOutletMasterlist(companyoutmaster);
  };

  const getDeliveryslotMenuList = async () => {  
    let outletId =restarantvalue.value;
    let getDplanList = await getDeliveryslotListMaster(outletId);
    let getListValue = getDplanList?.data?.data || [];
     setDeliverySlot(getListValue);
    // let totpage = Math.ceil(getListValue.length / itemsPerPage);
    // console.log("totpage",totpage);
    // setTotalPages(totpage);
    // console.log("totalPages",totalPages);
    // let titem= getListValue.length;
    // setTotalItems(titem); 
    // console.log("totalItems",totalItems);
    
  };
  // let actionOption = {
  //   name: "actions",
  //   label: "Actions",
  //   options: {
  //     filter: false,
  //     sort: false,
  //     customBodyRender: (summary, tableMeta, updateValue) => {
  //       return (
  //         <div className="list-action">
  //           <span
  //             style={{ color: "white", display: "flex" }}
  //             className="icon-top-left"
  //           >
  //             {/* <button
  //             type="button"
  //             className="rct-link-btn edit-btn"
  //             onClick={() => onEditUser(tableMeta)}
  //           >
  //             <i style={{ fontSize: "15px" }} className="ti-pencil"></i>
  //           </button> */}

  //             <Link
  //               className=""
  //               onClick={() => {
  //                 // setOutletDetails({})
  //                 approvalcall(tableMeta);
  //               }}
  //               // style={{ background: "#008000" }}
  //             >
  //               <i
  //                 className="fas fa-pencil-alt fa-lg tpen-bck"
  //                 style={{
  //                   display: "flex",
  //                   alignItems: "center",
  //                   marginLeft: "1px",
  //                 }}
  //               ></i>
  //             </Link>

  //             <Link
  //               className=""
  //               onClick={() => {
  //                 // setOutletDetails({})
  //                 viewDpoint(tableMeta);
  //               }}
  //               // style={{ background: "#008000" }}
  //             >
  //               <i
  //                 className="fa fa-eye tpen-bck"
  //                 style={{ marginLeft: "3px" }}
  //               ></i>
  //             </Link>
  //           </span>

  //           {/* <span style={{ paddingLeft: "20px",marginTop: "-20px" }} className="icon-top-left">

  //           <Link className="btn btn-primary shadow btn-xs sharp me-2"
  //             onClick={() => viewUser(tableMeta)} style={{ background: "#008000" }}
  //           >
  //             <i className="fa fa-eye"></i>
  //           </Link>
  //         </span> */}
  //         </div>
  //       );
  //     },
  //   },
  // };

  const handleChangePage = (event, newPage) => {
    setCurrentPage(newPage);
  };

  const onChangeRowsPerPage = (numOfRows) => {
    // let { currentPage, itemsPerPage } = this.state;
    setItemsPerPage(numOfRows);
  };

  const columns = [
    {
      name: "menuCategoryName",
      label: "Menu Slot Name",
      options: {
        filter: true,
        sort: true,
        fixedHeader: true,
        responsive: "stacked",
      },
    },

    {
      name: "slotId",
      label: "Delivery Slot ID",
      options: {
        filter: false,
        sort: true,
        fixedHeader: true,
        responsive: "stacked",
        filterType: "textField",
      },
    },

    {
      name: "startTime",
      label: "Start Time",
      options: {
        filter: true, // Enable filter for Restaurant
        sort: true,
        fixedHeader: true,
        responsive: "stacked",
      },
    },

    {
      name: "endTime",
      label: "End Time ",
      options: {
        filter: false,
        sort: true,
        customFilterListOptions: { render: (v) => `UID: ${v}` },
        fixedHeader: true,
        responsive: "stacked",
        filterType: "textField",
      },
    },
    {
      name: "status",
      label: "Status",
      options: {
        filter: false,
        sort: true,
        customFilterListOptions: { render: (v) => `UID: ${v}` },
        fixedHeader: true,
        responsive: "stacked",
        filterType: "textField",
      },
    },
   

    // actionOption,
  ];
  const options = {
    filter: true, 
    search: true, 
    selectableRows: false,
    responsive: "stacked",
    fixedHeader: true,
    tableBodyHeight: "51vh",
    fixedSelectColumn: true,
    page: currentPage,
    pagination: true,
    serverSide: false,
    rowsPerPage: itemsPerPage,
    rowsPerPageOptions: [10, 15, 100],
    onChangePage: (newPage) => {
      handleChangePage(newPage);
    },
    onChangeRowsPerPage: (numOfRows) => {
      onChangeRowsPerPage(numOfRows);
    },
    download: false,
    print: false,
    onFilterChange: (
      column,
      filterList,
      type,
      filterOptions,
      changedColumnIndex
    ) => {
     
    },
    confirmFilters: true,
    customFilterDialogFooter: (currentFilterList, applyNewFilters) => {
      return (
        <div style={{ marginTop: "40px" }}>
          <Button
            variant="contained"
            onClick={() => applyNewFilters()} 
          >
            Apply Filters
          </Button>
        </div>
      );
    },
    onFilterConfirm: (filterList) => {
    },
    onFilterDialogOpen: () => {
    },
    onFilterDialogClose: () => {
    },
    customToolbar: () => {
      return (
        <>
         
        </>
      );
    },
  };
 


  const themeTable = createMuiTheme({
    overrides: {
      MUIDataTable: {
        root: {
          backgroundColor: "#FF000",
        },
        paper: {
          boxShadow: "none",
        },
      },
      MuiTableRow: {
        root: {
          "&:nth-of-type(odd)": {
            backgroundColor: "white !important",
          },
          "&:nth-of-type(even)": {
            backgroundColor: "#e4e8ef !important",
          },
        },
      },

      MUIDataTableHeadCell: {
        root: {
          backgroundColor: "#008000 !important",
        },
        data: {
          fontWeight: "bold",
          color: "white",
          fontSize: "14px",
        },
      },
    },
  });

  return (
    <>
    <div className="row dly-slt">
        <div className="col-md-12 col-lg-12 col-sm-12 col-xl-12 temp-crd">
        <Card>
            <div class="row ovrl-crd-hd">
              <div class="col-3 col-md-3 col-lg-3">
                <div class="form-group">
                  <h3 className="me-auto main-hd">Delivery Slot</h3>
                </div>
              </div>
              <div class="col-9 col-md-9 col-lg-9 row" style={{marginTop:"-26px"}}>
                <Card.Header
                  className="card-title main-card"
                  // style={{ marginLeft: "300px" }}
                >
                  <div class="col-4 col-md-4 col-lg-4 form-group main-frm-grp" style={{zIndex:"800"}}>
                    <label as="a" variant="badge badge-rounded badge-danger">
                      Restaurant
                    </label>
                    <Select
                      options={outletMasterlist}
                      value={restarantvalue}
                      closeMenuOnSelect={false}
                      // search
                      // name="stateCode"
                      placeholder="Choose"
                      // autoComplete="off"
                      onChange={(event) => {
                        setRestarantvalue(event);
                       
                      }}
                    />
                  </div>
                 
                  <div
                    class=" col-2 col-md-2 col-lg-2 mt-5 mb-1 form-group"
                    style={{ width: "9.333333%" }}
                  >
                    {/* {selectedusers.value && selectedrestarant.value && */}

                    <Button
                      className="mt-2 btn-primary mn-hd-gt-btn"
                      variant="success dark btn-sm "
                      // disabled={restarantvalue.value == ""}
                      style={{
                        backgroundColor: "green",
                        borderRadius: "2px",
                        border: "0px solid",
                        // marginTop:"100px"
                      }}
                      onClick={() => {
                        getDeliveryslotMenuList();
                        // getOutletBasedList();
                      }}
                    >
                      <i
                        // class="fas fa-plus"
                        onClick={() => {}}
                      >
                        Get{" "}
                      </i>{" "}
                    </Button>

                    {/* } */}
                  </div>

                  <div
                    class=" col-2 col-md-2 col-lg-2 mt-5 mb-1  form-group"
                    style={{ width: "9.333333%", marginLeft: "-20px" }}
                  >
                    {/* {selectedusers.value && selectedrestarant.value && */}

                    <Button
                      className="mt-2 btn-primary mn-hd-gt-clr"
                      variant="success dark btn-sm "
                      // disabled={restarantvalue.value == ""}
                      style={{
                        backgroundColor: "red",
                        borderRadius: "2px",
                        border: "0px solid",
                      }}
                      onClick={() => {
                        getDeliveryslotMenuList();
                        // getwhatsappMsgTemplist();
                        setRestarantvalue({});
                      }}
                    >
                      <i
                        // class="fas fa-plus"
                        onClick={() => {}}
                      >
                        Clear{" "}
                      </i>{" "}
                    </Button>

                    {/* } */}
                  </div>
                 
                </Card.Header>
              </div>
            </div>

            <Card.Body
              className="scroll-tbl-fix-header tab-hd-clr"
              style={{ padding: "3px" }}
            >
                <RctCollapsibleCard fullBlock>
              <RctCollapsibleCard fullBlock>
                <MuiThemeProvider theme={themeTable}>
                  <MUIDataTable
                    title={""}
                    data={deliverySlot}
                    columns={columns}
                    options={options}
                    columOrder={columns}
                    className={"MuiTabCusCls"}
                  />
                </MuiThemeProvider>
              </RctCollapsibleCard>
            </RctCollapsibleCard>
              {/* <Table responsive stripped>
                <thead>
                  <tr>
                    <th>Menu Slot Name</th>
                    <th>Delivery slot ID</th>
                   
                    <th>Start Time</th>
                    <th>End Time</th>
                    { <th>Status</th> }
                  </tr>
                </thead>
                { <tbody>
                  {deliverySlot &&
                    deliverySlot.map((items) => {
                      return (
                        <tr>
                          <td>{items.menuCategoryName}</td>
                          <td>{items.slotId}</td>
                          <td>{items.startTime}</td>
                          <td>{items.endTime}</td>
                          <td>{items.status}</td>
    
                        </tr>
                      );
                    })}
                  {deliverySlot?.length <= 0 ? (
                    <div style={{ color: "red", textAlign: "center" }}>
                      {" "}
                      No Data Found{" "}
                    </div>
                  ) : (
                    setDeliverySlot
                  )}
                </tbody> }
              </Table> */}
            </Card.Body>
          </Card> 
          
          </div></div>
    </>
  )
}

export default Deliveryslot